import { render } from "./P085.vue?vue&type=template&id=5e027215&scoped=true"
import script from "./P085.vue?vue&type=script&lang=js"
export * from "./P085.vue?vue&type=script&lang=js"

import "./P085.vue?vue&type=style&index=0&id=5e027215&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e027215"]])

export default __exports__